import { collection, getDocs, updateDoc, doc } from 'firebase/firestore';
import { db } from '../lib/firebase';

/**
 * Attribue tous les rapports sans `createdBy` à un admin choisi.
 *
 * Action de maintenance ponctuelle : parcourt les 6 collections de rapports et
 * pose `createdBy = adminId` (+ `migratedCreatedBy: true`) sur chaque document
 * qui n'a pas encore d'auteur. Permet à la règle "l'auteur peut éditer/supprimer
 * son rapport" de s'appliquer aussi à l'historique.
 */

const REPORT_COLLECTIONS = [
  { name: 'adnReports', displayName: 'ADN' },
  { name: 'financeReports', displayName: 'Finance' },
  { name: 'academieReports', displayName: 'Académie' },
  { name: 'sainteCeneReports', displayName: 'Sainte Cène' },
  { name: 'sonoReports', displayName: 'Communication & Sono' },
  { name: 'worshipReports', displayName: 'Culte' },
] as const;

export interface OrphanMigrationResult {
  perCollection: { collection: string; displayName: string; migrated: number }[];
  totalMigrated: number;
}

export async function migrateOrphanReportsToAdmin(
  adminId: string
): Promise<OrphanMigrationResult> {
  if (!adminId) {
    throw new Error('Aucun administrateur sélectionné pour la migration.');
  }

  const result: OrphanMigrationResult = {
    perCollection: [],
    totalMigrated: 0,
  };

  for (const { name, displayName } of REPORT_COLLECTIONS) {
    let migrated = 0;
    const snapshot = await getDocs(collection(db, name));

    for (const reportDoc of snapshot.docs) {
      const data = reportDoc.data() as { createdBy?: string };
      if (data.createdBy) continue;

      await updateDoc(doc(db, name, reportDoc.id), {
        createdBy: adminId,
        migratedCreatedBy: true,
        updatedAt: new Date(),
      });
      migrated++;
    }

    result.perCollection.push({ collection: name, displayName, migrated });
    result.totalMigrated += migrated;
  }

  return result;
}
